import React, { useState, useEffect } from 'react';
import { Box, HStack, Text, IconButton, Link, Button, VStack, Spacer, Stack, Badge } from "@chakra-ui/react";
import { RiThumbDownLine, RiThumbUpLine } from "react-icons/ri";
import Feedback from './shared/Feedback';

import { DataStore } from '@aws-amplify/datastore';
import { Interactions } from '../../models';
import { Auth } from 'aws-amplify';

import image from '../../assets/central.jpg';

function Central(sessionContext) {

    const [count, setCount] = useState(0);
    const [clickCounter, setClickCounter] = useState(0);
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [intersectionObserver, setIntersectionObserver] = useState(null);


    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsTimerRunning(true);
                } else {
                    setIsTimerRunning(false);
                }
            },
            {
                root: null,
                rootMargin: "0px",
                threshold: [0, 1]
            }
        );

        setIntersectionObserver(observer);

        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        if (!intersectionObserver) {
            return;
        }

        const widgetEl = document.getElementById(Central.name);
        intersectionObserver.observe(widgetEl);

        return () => {
            intersectionObserver.unobserve(widgetEl);
        };
    }, [intersectionObserver]);

    useEffect(() => {
        let timerId = null;

        if (isTimerRunning) {
            timerId = setInterval(() => {
                setCount(count + 1);
            }, 1000);
        }

        return () => {
            clearInterval(timerId);
        };
    }, [isTimerRunning, count]);

    const [userID, setUserID] = useState("");
    const [userRole, setUserRole] = useState("");

    useEffect(() => {
        const getUserID = async () => {
            const user = await Auth.currentAuthenticatedUser();
            setUserID(user.attributes.sub);
            setUserRole(user.attributes['custom:role']);
        };
        getUserID();
    }, []);

    const getTime = () => {
        var today = new Date();
        var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        var dateTime = date + ' ' + time;
        return dateTime;
    }


    async function logInteraction() {
        await DataStore.save(
            new Interactions({
                "userSub": userID,
                "long": sessionContext.sessionContext.position.longitude,
                "lat": sessionContext.sessionContext.position.latitude,
                "time": getTime(),
                "feedbackType": "USEFUL_WIDGET",
                "interactionType": "CLICKED",
                "userID": userID,
                "duration": count,
                "clicks": clickCounter,
                "widgetName": "Outlet Widget",
                "UserRole": userRole.toUpperCase()
            })
        );
        // open google maps with directions to Pendle Rooms 54.4913735,-2.7542582
        window.open("https://www.google.com/maps/dir//Central+-+Lancaster+University+Students'+Union+Convenience+Store/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x487b6302362d1c3b:0xd9f69d80fb21bcdf?sa=X&ved=2ahUKEwjg9Jig4Ln_AhVOZ8AKHT22CYwQ9Rd6BAhcEAU", "_blank");
    }

    const styles = {
        box: {
            width: '100%',
            height: '150px',
            backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.8), transparent), url(${image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }
    };

    return (
        <>
            <Box
                id={Central.name}
                w="100%"
                h="315px"
                bg={`linear-gradient(to bottom, ${'#933C39'}, ${'#882A26'})`}
                borderRadius="15px"
                onClick={() => setClickCounter(clickCounter + 1)}
            >
                <Box
                    w="100%"
                    h="130px"
                    px={4}
                    py={3}
                    borderTopRadius="15px"
                    style={styles.box}
                >
                    <VStack alignItems={"flex-start"} justifyContent="end" h="100%">
                        <Badge borderRadius="full" px="2" colorScheme="black" my="80px">
                            Based on your location
                        </Badge>
                        <Box
                            bg={"white"}
                            w="60px"
                            h="19px"
                            borderRadius="100px"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <Text fontSize="sm" fontWeight="normal" my="30px" color={"black"}>
                                Open
                            </Text>
                        </Box>
                    </VStack>
                </Box>
                <Box w="100%" h="50px" px={4} pt={4} pb={0}>
                    <HStack alignItems="center" justifyContent="space-between">
                        <Text fontSize="md" fontWeight="bold" mb={0} color={"whiteAlpha.800"}>
                            Central - Lancaster University
                        </Text>
                        <Feedback widgetName="Outlet Widget" sessionContext={sessionContext} clicks={clickCounter} />
                    </HStack>
                </Box>
                <Stack direction={"column"} spacing={3} w="100%" px={4} py={0}>
                    <Text fontSize="xs" fontWeight="normal" mb={2} color={"whiteAlpha.800"}>
                        We own and operate Central, our on-campus convenience store.
                    </Text>
                    <Button onClick={logInteraction} colorScheme="green" variant="outline" size="sm" ml={4} mb={0} mt={0} py={3} borderRadius="100px" color={"whiteAlpha.800"} borderColor={"whiteAlpha.800"} _hover={{ bg: "whiteAlpha.800", color: "black" }}>
                        Get Directions
                    </Button>
                </Stack>
            </Box>
        </>
    );
}

export default Central;